<template>
  <h5 class="modal-title">
    {{ title }}
  </h5>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>

<style lang="sass" scoped>
    .modal-title
        font-size: 18px
        font-weight: 600
        position: absolute
        width: 100%
        left: 0
        text-align: center
        margin: auto 0
</style>